const videoBtns = document.querySelectorAll('.video__play-button');

if (videoBtns) {
    videoBtns.forEach(el => {
        el.addEventListener('click', () => {
            // Select the template element of the current element
            const template = el.parentElement.querySelector('.js-video-template');

            if (!template) {
                return;
            }

            // Select the parent element of the template
            const parent = template.parentNode;

            if (!parent) {
                return;
            }

            // Copy of the template content
            const clone = template.content.cloneNode(true);

            const btnPlay = parent.querySelector('.video__play-button');
            if (btnPlay) {
                btnPlay.remove();
            }

            const image = parent.querySelector('.img-fluid');

            if (image) {
                image.remove();
            }

            // Select the iframe within the clone template
            const iframe = clone.querySelector('.video__container');

            if (iframe) {
                parent.appendChild(iframe); // Append the iframe to the parent element
            }
        });
    });
}
